import { HexColorPicker } from "react-colorful";
import { Popover, PopoverContent, PopoverTrigger } from "@heroui/react";
import classNames from "classnames";

type CropZoneColorPickerProps = {
    value: string;
    onChange: (color: string) => void;
    ariaLabel: string;
    size?: "sm" | "md";
};

function CropZoneColorPicker({
    value,
    onChange,
    ariaLabel,
    size = "md",
}: CropZoneColorPickerProps) {
    return (
        <Popover placement="bottom-start" showArrow>
            <PopoverTrigger>
                <button
                    type="button"
                    className={classNames(
                        "shrink-0 cursor-pointer overflow-hidden rounded-md",
                        size === "sm" ? "h-7 w-7" : "h-8 w-8",
                    )}
                    style={{ backgroundColor: value }}
                    aria-label={ariaLabel}
                />
            </PopoverTrigger>
            <PopoverContent className="p-3">
                <HexColorPicker
                    color={value}
                    onChange={onChange}
                    className="!w-[200px]"
                />
            </PopoverContent>
        </Popover>
    );
}

export default CropZoneColorPicker;
